// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/AppleSDGothicNeoT.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/AppleSDGothicNeoUL.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../font/AppleSDGothicNeoL.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../font/AppleSDGothicNeoR.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../font/AppleSDGothicNeoM.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../font/AppleSDGothicNeoSB.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../font/AppleSDGothicNeoB.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../font/AppleSDGothicNeoEB.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../font/AppleSDGothicNeoH.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}
@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 200;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}

@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}

@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}

@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
}

@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
}

@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2");
}

@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2");
}

@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2");
}

@font-face {
  font-family: 'AppleSDGothicNeo';
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}


* {
  font-family: 'AppleSDGothicNeo', sans-serif;
  box-sizing: border-box;
}

html,
body {
  max-width: 100%;
}

html,
body,
#root {
  height: 100%;
}

html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
abbr,
address,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
samp,
small,
strong,
sub,
sup,
var,
b,
i,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
}

body {
  line-height: 1;
  background-color: #000;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

ul,
ol {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}

a {
  margin: 0;
  padding: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  text-decoration: none;
}

/* change colours to suit your needs */
ins {
  background-color: #ff9;
  color: #000;
  text-decoration: none;
}

/* change colours to suit your needs */
mark {
  font-style: normal;
  font-weight: 400;
}

del {
  text-decoration: line-through;
}

abbr[title],
dfn[title] {
  border-bottom: 1px dotted;
  cursor: help;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

/* change border colour to suit your needs */
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #cccccc;
  margin: 1em 0;
  padding: 0;
}

input[type='text'],
input[type='email'],
input[type='password'],
select {
  vertical-align: middle;
}
i {
  font-style: normal;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 400;
}
button {
  background-color: transparent;
  border: 0;
  margin: 0;
  padding: 0;
}

textarea:focus-visible {
  outline: 0px;
}

input:focus-visible {
  outline: 0px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/reset.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAuD;AACzD;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAwD;AAC1D;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAwD;AAC1D;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAwD;AAC1D;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4DAAuD;AACzD;;;AAGA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqEE,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;;;;;;;;;EAWE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,UAAU;AACZ;;AAEA;;;;EAIE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 100;\n  src: url(../font/AppleSDGothicNeoT.ttf) format(\"woff2\");\n}\n@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 200;\n  src: url(../font/AppleSDGothicNeoUL.ttf) format(\"woff2\");\n}\n\n@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 300;\n  src: url(../font/AppleSDGothicNeoL.ttf) format(\"woff2\");\n}\n\n@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 400;\n  src: url(../font/AppleSDGothicNeoR.ttf) format(\"woff2\");\n}\n\n@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 500;\n  src: url(../font/AppleSDGothicNeoM.ttf) format(\"woff2\");\n}\n\n@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 600;\n  src: url(../font/AppleSDGothicNeoSB.ttf) format(\"woff2\");\n}\n\n@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 700;\n  src: url(../font/AppleSDGothicNeoB.ttf) format(\"woff2\");\n}\n\n@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 800;\n  src: url(../font/AppleSDGothicNeoEB.ttf) format(\"woff2\");\n}\n\n@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 900;\n  src: url(../font/AppleSDGothicNeoH.ttf) format(\"woff2\");\n}\n\n@font-face {\n  font-family: 'AppleSDGothicNeo';\n  font-weight: 100;\n  src: url(../font/AppleSDGothicNeoT.ttf) format(\"woff2\");\n}\n\n\n* {\n  font-family: 'AppleSDGothicNeo', sans-serif;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  max-width: 100%;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\nhtml,\nbody,\ndiv,\nspan,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\nabbr,\naddress,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\nsamp,\nsmall,\nstrong,\nsub,\nsup,\nvar,\nb,\ni,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  font-size: 100%;\n  vertical-align: baseline;\n  background: transparent;\n}\n\nbody {\n  line-height: 1;\n  background-color: #000;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nul,\nol {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: '';\n  content: none;\n}\n\na {\n  margin: 0;\n  padding: 0;\n  font-size: 100%;\n  vertical-align: baseline;\n  background: transparent;\n  text-decoration: none;\n}\n\n/* change colours to suit your needs */\nins {\n  background-color: #ff9;\n  color: #000;\n  text-decoration: none;\n}\n\n/* change colours to suit your needs */\nmark {\n  font-style: normal;\n  font-weight: 400;\n}\n\ndel {\n  text-decoration: line-through;\n}\n\nabbr[title],\ndfn[title] {\n  border-bottom: 1px dotted;\n  cursor: help;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n/* change border colour to suit your needs */\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #cccccc;\n  margin: 1em 0;\n  padding: 0;\n}\n\ninput[type='text'],\ninput[type='email'],\ninput[type='password'],\nselect {\n  vertical-align: middle;\n}\ni {\n  font-style: normal;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 400;\n}\nbutton {\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\ntextarea:focus-visible {\n  outline: 0px;\n}\n\ninput:focus-visible {\n  outline: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
